var React = require('react');

function Spotify (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25,0A25,25,0,1,0,50,25v-.00038A25,25,0,0,0,25,0ZM36.46523,36.05886a1.55708,1.55708,0,0,1-2.13975.5201l-.00269-.00164c-5.87071-3.58816-13.25992-4.39843-21.96212-2.41064a1.55774,1.55774,0,0,1-.7003-3.03575l.00655-.00149C21.19,28.95236,29.35884,29.8892,35.94835,33.91593a1.55839,1.55839,0,0,1,.51725,2.14233Zm3.05912-6.80755a1.95017,1.95017,0,0,1-2.681.64186C30.125,25.76343,19.88017,24.56711,11.93182,26.9798A1.94882,1.94882,0,0,1,10.799,23.25041c9.07992-2.75528,20.36752-1.4208,28.08406,3.3213A1.94922,1.94922,0,0,1,39.52435,29.25131Zm.2639-7.08834c-8.0586-4.78575-21.351-5.22577-29.04392-2.89086a2.33819,2.33819,0,1,1-1.3627-4.47343l.00521-.00158c8.8309-2.68066,23.511-2.16283,32.7882,3.34419A2.33831,2.33831,0,0,1,39.78825,22.163Z","fill":"#10141a"}));
}

Spotify.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = Spotify;

Spotify.default = Spotify;
